var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PageContentLayoutOnly',{attrs:{"invoice-conversation-messages":"","role":"region","new-conversation":""}},[_c('ListApInvoiceConversations',{attrs:{"apInvoiceID":parseInt(_vm.apInvoiceID)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }